import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    search = '',
    pi = 1,
    ps = 50,
    sort = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.getMyOrgPage, {
        search,
        sort,
        pi,
        ps,
    }, options);
    if (error) return { error, status };
    return content || { rows: [], total: 0, pc: 0, pi, ps };
};
